import algoliasearch from 'algoliasearch/lite'

export default algoliasearch('ANAEEWG1X1', '9a302d1211521012e28382c34f708f45')
